import React, { useState } from "react";
import { Row, Col, Form, Table } from "react-bootstrap";
import moment from "moment";
import obj, { headerData } from "../../utils/constants";
import constants from "../../utils/helpers";
import Loader from "../../assets/gif/loader.gif";
import { capitalize, startCase } from "lodash";

const Exchange = ({ title, data, isLoader }) => {
  const [active, setActive] = useState([]);
  return (
    <div className="common-container">
      <Form className="bet_status mb-3">
        <Row>
          <Col xl={11} md={12}>
            <Row className="align-items-center">
              <Col lg={3} sm={6} className="mb-lg-0 mb-3">
                <div className="bet-sec d-flex align-items-center">
                  <Form.Label className="mb-0">Bet Status:</Form.Label>
                  <Form.Select aria-label="Default select example">
                    <option>All</option>
                    <option value="1">UnMatched</option>
                    <option value="2">Matched</option>
                  </Form.Select>
                </div>
              </Col>
              <Col lg={4}>
                <div className="d-flex align-items-center">
                  <Form.Label className="mb-0 me-2">Order By:</Form.Label>
                  <Form.Check
                    aria-label="option 1"
                    label="Bet Placed"
                    className="mb-0 me-2 d-flex align-items-center"
                  />
                  <Form.Check
                    aria-label="option 1"
                    label="Market"
                    className="mb-0 me-2 d-flex align-items-center"
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
      {/* {isLoader ? (
        <span className="d-flex justify-content-center align-item-center mt-2 pb-3">
          <img src={Loader} alt="No_Image" />
        </span>
      ) : */}
      {
        <section className="account-table my-bet-sec mt-2">
          <div className="profile-tab">
            {title === "Exchange" && (
              <div className="my_account_table_wrap">
                <h5>UnMatched</h5>
                <div className="table-main-wrapper">
                  <Table className="table_caption_style">
                    <thead>
                      <tr>
                        {headerData.map((res) => {
                          return (
                            <th
                              scope="col"
                              className={res.class}
                              width={res.widht}
                            >
                              {res.title}
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {data && data?.unMatched?.length > 0 ? (
                        data?.unMatched?.map((item) => {
                          return (
                            <tr>
                              <td className="text-start" width="30%">
                                {item?.matchName || "N/A"}
                              </td>
                              <td className="text-end">
                                {obj.betCheckObj[item?.eventType]}
                              </td>
                              <td className="text-end">
                                {" "}
                                {item?.selectionId || "N/A"}
                              </td>
                              <td className="text-end">
                                <span
                                  className={
                                    item?.betType == "lay" || item?.type == "No"
                                      ? "lay-bg"
                                      : item?.betType == "back" ||
                                        item?.type == "Yes"
                                      ? "back-bg"
                                      : ""
                                  }
                                >
                                  {item?.betType || item?.type}
                                </span>
                              </td>
                              <td className="text-end">
                                {" "}
                                {item?.matchBetId || "N/A"}
                              </td>
                              <td className="text-end">
                                {" "}
                                {item?.amount || "N/A"}
                              </td>
                              <td className="text-end">
                                {" "}
                                {item?.bhav || "N/A"}
                              </td>
                              <td className="text-end">
                                {" "}
                                {item?.matchName || "N/A"}{" "}
                              </td>
                              <td className="text-end">
                                {" "}
                                {item?.matchName || "N/A"}{" "}
                              </td>
                              <td>
                                {item?.betType == "back" ||
                                item?.type == "Yes" ? (
                                  <span className="text-success">
                                    {item?.profitAmount.toFixed(2)}
                                  </span>
                                ) : (
                                  <span className="text-danger">
                                    -({item?.loseAmount.toFixed(2)})
                                  </span>
                                )}
                              </td>
                              <td>
                                {" "}
                                {moment(item?.timeInserted).format(
                                  "YYYY-MM-DD, h:mm:ss"
                                )}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="12" className="text-start">
                            <span>You have no bets in this time period.</span>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            )}
            <div className="my_account_table_wrap">
              <h5>Matched</h5>
              <div className="table-main-wrapper">
                <Table className="table_caption_style">
                  <thead>
                    <tr>
                      {headerData.map((res) => {
                        return (
                          <th
                            scope="col"
                            className={res.class}
                            width={res.widht}
                          >
                            {res.title}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>

                  <tbody>
                    {data &&
                    (title === "Exchange" ? data?.matched : data)?.length >
                      0 ? (
                      (title === "Exchange" ? data?.matched : data)?.map(
                        (item) => {
                          return (
                            <>
                              <tr>
                                <td className="text-start" width="30%">
                                  <span style={{ textTransform: "uppercase" }}>
                                    {obj.betCheckObj[item?.eventType]}
                                  </span>
                                  <img
                                    class="fromto"
                                    src={require("../../assets/images/transparent.gif")}
                                  />
                                  <strong>{item?.matchName}</strong>
                                  <img
                                    class="fromto"
                                    src={require("../../assets/images/transparent.gif")}
                                  />
                                  {capitalize(item?.betFaireType) ||
                                    item?.fancyName}
                                </td>
                                <td className="text-end">
                                  {" "}
                                  {item?.runnerName
                                    || item?.teamName}
                                </td>
                                <td className="text-end">
                                  <span
                                    className={
                                      item?.betType == "lay" ||
                                      item?.type == "No"
                                        ? "lay-bg"
                                        : item?.betType == "back" ||
                                          item?.type == "Yes"
                                        ? "back-bg"
                                        : ""
                                    }
                                  >
                                    {title === "FancyBet"
                                      ? capitalize(item?.type)
                                      : capitalize(item?.betType)}
                                  </span>
                                </td>
                                <td className="text-end">
                                  {" "}
                                  <span
                                    onClick={() =>
                                      setActive((prev) => {
                                        if (prev?.includes(item?._id)) {
                                          return prev?.filter((res) => {
                                            return res !== item?._id;
                                          });
                                        } else {
                                          return [...prev, item?._id];
                                        }
                                      })
                                    }
                                    style={{ borderBottom: "1px solid" ,cursor:"pointer"}}
                                    className="back-bg"
                                  >
                                    {" "}
                                    {title === "FancyBet"
                                      ? item?.selectionId
                                      : item?.matchBetId}
                                  </span>
                                </td>
                                <td className="text-end">
                                  {moment(item?.timeInserted).format(
                                    "YYYY-MM-DD hh:mm:ss"
                                  )}
                                </td>
                                <td className="text-end">
                                  {" "}
                                  {title === "FancyBet"
                                              ? item?.betRun + "/" + item?.bhav
                                              : item?.bhav || "N/A"}
                                </td>
                                <td className="text-end">
                                  {" "}
                                  {item?.amount || "N/A"}{" "}
                                </td>{" "}
                                <td className="text-end">
                                  {" "}
                                  {title === "FancyBet"
                                              ? item?.betRun + "/" + item?.bhav
                                              : item?.bhav || "N/A"}
                                </td>
                                <td className="text-end">
                                  {moment(item?.timeInserted).format(
                                    "YYYY-MM-DD hh:mm:ss"
                                  )}
                                </td>
                              </tr>
                              {active.includes(item?._id) && (
                                <tr
                                  className="expand new-bethistory-slip"
                                  id={item?._id}
                                >
                                  <td
                                    style={{ background: "#e2e8ed" }}
                                    colSpan={"2"}
                                  ></td>
                                  <td
                                    colSpan="9"
                                    style={{ background: "#e2e8ed" }}
                                    className="new-bethistory-slip-td"
                                  >
                                    <img
                                      class="expand-arrow"
                                      src={require("../../assets/images/transparent.gif")}
                                    ></img>
                                    <table>
                                      <tbody>
                                        <tr>
                                          <th>Bet Taken</th>
                                          <th>Odds req.</th>
                                          <th>Stake</th>
                                          <th>Liability</th>
                                          <th>Odds Matched</th>
                                        </tr>
                                        <tr
                                          id="txRow0"
                                          style={{ display: "table-row" }}
                                          className="even"
                                        >
                                          <td className="text-end">
                                            {" "}
                                            {moment(item?.timeInserted).format(
                                              "YYYY-MM-DD hh:mm:ss"
                                            )}
                                          </td>
                                          <td className="text-end">
                                            {" "}
                                            {title === "FancyBet"
                                              ? item?.betRun + "/" + item?.bhav
                                              : item?.bhav || "N/A"}
                                          </td>{" "}
                                          <td className="text-end">
                                            {" "}
                                            {item?.amount || "N/A"}
                                          </td>
                                          <td className="text-end"><span className="text-danger">
                                              ({item?.loseAmount.toFixed(2)})
                                            </span></td>
                                          <td className="text-end">
                                            {" "}
                                            {title === "FancyBet"
                                              ? item?.betRun + "/" + item?.bhav
                                              : item?.bhav || "N/A"}
                                          </td>{" "}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              )}
                            </>
                          );
                        }
                      )
                    ) : (
                      <tr>
                        <td colSpan="12" className="text-start">
                          <span>You have no bets in this time period.</span>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </section>
      }
    </div>
  );
};
export default Exchange;
